/**
 * Tenant settings REST client (v4.1 Phase 37.2).
 *
 * Auth: tenant-admin on the caller's tenant OR super-admin with
 * X-Tenant-Id override (handled transparently by the shared request
 * helper + the admin-panel tenant switcher).
 */

import { request } from "./api.js";

export const getTenantSettings = () => request("/api/admin/tenant-settings");

export const updateTenantSettings = (patch) =>
  request("/api/admin/tenant-settings", {
    method: "PUT",
    body: JSON.stringify(patch),
  });
